import type {SVGProps} from 'react'
const BrandRegisterIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 100 100"
    width="1em"
    height="1em"
    {...props}
  >
    <g
      style={{
        mixBlendMode: 'multiply',
      }}
    >
      <path
        fill="#2d2e2c"
        d="M66.62 24a3 3 0 0 1 3 3v4.777h-1V27a2 2 0 0 0-2-2H15.147a2 2 0 0 0-2 2v38.769h47.119v1H12.148V27a3 3 0 0 1 3-3z"
      />
      <path stroke="#2d2e2c" strokeWidth={1.5} d="M12 69.25h49" />
      <rect
        width={25.232}
        height={44.836}
        x={61.016}
        y={32.527}
        stroke="#2d2e2c"
        strokeWidth={1.5}
        rx={1.25}
      />
      <path stroke="#2d2e2c" d="M16.934 28.792h3.386M22.246 28.792h3.386M27.55 28.792h3.387" />
    </g>
  </svg>
)
export {BrandRegisterIcon}
